import store from 'redux/store';
import { showDialog } from 'dialogs';
import type { Zone } from 'redux/slices/lists/zonesSlice';
import EditZoneModal from '../EditZoneModal';

export type ShowEditZoneArgs = { readonly mode: 'create' } | { readonly mode: 'edit'; readonly id: number };

// The modal takes the full record inline (no single-zone load endpoint); read it
// from the flat list the store already holds, by id.
const findZone = (id: number): Zone | null => store.getState().listOfZones.zones.find((zone) => zone.zone_id === id) ?? null;

/**
 * Open the zone create / edit modal. Mounts the existing `EditZoneModal` via
 * `showDialog` (no MobX upgrade). The modal persists through the zone thunks and
 * the slice reducers update the list in place, so there is no saved-signal to
 * thread back.
 */
export const showEditZone = (args: ShowEditZoneArgs): void => {
  const data = args.mode === 'create' ? null : findZone(args.id);
  showDialog((close) => <EditZoneModal show handleClose={close} mode={args.mode} data={data} />);
};
